/* ALR — Reviews & Ratings
   Drawer behaviour, plus opening Judge.me's own review form.

   HOW THE FORM WORKS (verified on this store, 2026-09-05):
   Judge.me's v3 Reviews Widget renders as an @app block inside [data-rv-jdgm],
   which is visually hidden. Its "Write a review" trigger is button.jm-button.
   Clicking it opens .jdgm-write-review-modal, which Judge.me appends to <body>
   — so nothing needs relocating, and the hidden host does not prevent it.
   Note the namespace split: the widget uses jm-*, the modal uses jdgm-*. */
(function () {
  'use strict';

  var MODAL = '.jdgm-write-review-modal';

  /* The band belongs under the product info column. It cannot get there with
     margins: .pd is a two-column grid and the gallery column is usually the
     taller of the two, by an amount that changes per product. So we move the
     element into .pd-info and let the column carry it. Templates without that
     column keep the mirrored grid defined in the CSS. */
  function seat(root) {
    var col = document.querySelector('.pd-info');
    if (!col || root.parentNode === col) return;

    /* The theme editor re-renders our section in place, leaving whatever we
       moved out of it behind. Clear the previous copies first. */
    var staleRoot = document.getElementById(root.id);
    if (staleRoot && staleRoot !== root && staleRoot.parentNode) {
      staleRoot.parentNode.removeChild(staleRoot);
    }
    var staleOv = document.getElementById('alr-rv-ov-' + root.getAttribute('data-rv-root'));
    if (staleOv && !root.contains(staleOv) && staleOv.parentNode) {
      staleOv.parentNode.removeChild(staleOv);
    }

    col.appendChild(root);
    root.classList.add('alr-rv--seated');
  }

  function init(root) {
    if (root.dataset.rvReady) return;
    root.dataset.rvReady = '1';

    seat(root);

    var uid = root.getAttribute('data-rv-root');
    var ov = document.getElementById('alr-rv-ov-' + uid);
    var jdgmHost = root.querySelector('[data-rv-jdgm]');
    var writeBtn = root.querySelector('[data-rv-write]') || (ov && ov.querySelector('[data-rv-write]'));

    /* ---------- drawer ---------- */
    if (ov) {
      var openBtn = root.querySelector('[data-rv-open]');
      var closeBtn = ov.querySelector('[data-rv-close]');
      var panel = ov.querySelector('[data-rv-panel]');
      var lastFocus = null;

      /* Move the overlay to <body> so no transformed ancestor can trap position:fixed. */
      if (ov.parentNode !== document.body) document.body.appendChild(ov);

      var openDrawer = function () {
        lastFocus = document.activeElement;
        ov.hidden = false;
        requestAnimationFrame(function () { ov.classList.add('is-open'); });
        document.documentElement.style.overflow = 'hidden';
        if (closeBtn) closeBtn.focus();
      };
      var closeDrawer = function () {
        ov.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        window.setTimeout(function () { ov.hidden = true; }, 300);
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      };

      if (openBtn) openBtn.addEventListener('click', openDrawer);
      if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
      ov.addEventListener('mousedown', function (e) { if (e.target === ov) closeDrawer(); });

      document.addEventListener('keydown', function (e) {
        if (ov.hidden) return;
        /* Let Judge.me's modal own Escape while it is open. */
        if (document.querySelector(MODAL)) return;
        if (e.key === 'Escape') { closeDrawer(); return; }
        if (e.key === 'Tab' && panel) {
          var f = panel.querySelectorAll('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])');
          if (!f.length) return;
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });

      document.addEventListener('shopify:section:select', function (e) {
        if (e.detail && e.detail.sectionId && root.id.indexOf(e.detail.sectionId) === -1) return;
        openDrawer();
      });
      document.addEventListener('shopify:section:deselect', function () { closeDrawer(); });
    }

    /* ---------- rate this piece ---------- */
    if (!writeBtn || !jdgmHost) return;

    function trigger() {
      return jdgmHost.querySelector('button.jm-button') ||
             jdgmHost.querySelector('.jdgm-write-rev-link');
    }

    /* Their modal must clear our drawer, which sits at z-index 9999. */
    function liftModal() {
      var tries = 0;
      var t = window.setInterval(function () {
        tries++;
        var m = document.querySelector(MODAL);
        if (m) { m.style.zIndex = '100000'; window.clearInterval(t); }
        else if (tries > 40) window.clearInterval(t);
      }, 100);
    }

    function openForm() {
      var t = trigger();
      if (t) { t.click(); liftModal(); return; }

      /* Their widget renders asynchronously — wait for the trigger, briefly. */
      writeBtn.setAttribute('aria-busy', 'true');
      var tries = 0;
      var poll = window.setInterval(function () {
        tries++;
        var b = trigger();
        if (b) {
          window.clearInterval(poll);
          writeBtn.removeAttribute('aria-busy');
          b.click();
          liftModal();
        } else if (tries > 60) {
          window.clearInterval(poll);
          writeBtn.removeAttribute('aria-busy');
          writeBtn.textContent = 'Rating form unavailable — please refresh';
          writeBtn.disabled = true;
        }
      }, 250);
    }

    writeBtn.addEventListener('click', openForm);
  }

  function boot() {
    var roots = document.querySelectorAll('[data-rv-root]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
